import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import NavBar from "../NavBar/NavBar";
import Home from "../../pages/Home";

import GlobalProvider from "../../context/Provider";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#102A43",
      dark: "#081B2D",
      light: "#284B68",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F47A1F",
      dark: "#C9570B",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#16815D",
      dark: "#0E6548",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F3F6F8",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#102A43",
      secondary: "#5C6F7F",
    },
    divider: "#DCE4EA",
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Manrope", "Segoe UI", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: "-0.04em",
    },
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.03em",
    },
    h3: {
      fontWeight: 750,
      letterSpacing: "-0.02em",
    },
    button: {
      fontWeight: 700,
      textTransform: "none",
      letterSpacing: 0,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          minHeight: 44,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
        },
      },
    },
  },
});

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <NavBar />
          <Route path="/" exact component={Home} />
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default GlobalProvider(App);
